"use strict";
/* eslint no-param-reassign: ["error", { "props": false }] */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var extendDataLayer_1 = __importDefault(require("./helpers/extendDataLayer"));
var PageAnalyze_1 = __importDefault(require("./PageAnalyze"));
var GtmInteractions_1 = __importDefault(require("./GtmInteractions"));
/**
 * Klasa realizująca translację standardowych parametrów GTM (yr_gtm_*)
 * na wymagane przez Criteo oraz generująca zdarzenia GTMowe
 *
 * Dodatkowo wykonuje request do /gtm-converteo/params w celu generacji
 * parametrów unikalnych dla tej integracji
 */
var GtmConverteo = /** @class */ (function () {
    function GtmConverteo(document, location) {
        this.mapping = {
            /* eslint-disable @typescript-eslint/camelcase */
            yr_gtm_g: ['nbOrders'],
            yr_gtm_ab: ['offerSegment'],
            yr_gtm_d: ['sessionFingerprint'],
            yr_gtm_e: ['userAccount'],
            yr_gtm_f: ['userType'],
            yr_gtm_h: ['lastPurchaseDate'],
            yr_gtm_k: ['lastOrderValue'],
            yr_gtm_l: ['aov90Days'],
            yr_gtm_m: ['lastOrderProductsSkuTable'],
            yr_gtm_n: ['lastOrderGiftsSkuTable'],
            yr_gtm_o: ['topProductsSku360Days'],
            yr_gtm_o1: ['topProductsSku90Days'],
            yr_gtm_p: ['topGiftsSku360Days'],
            yr_gtm_s: ['whishlistSku'],
            yr_gtm_aa: ['sessionStatus'],
            yr_gtm_ae: ['previousVisitDate'],
            yr_gtm_ag: ['visitCount360days'],
            yr_gtm_x: ['incrementalSkuViewedProduct'],
            yr_gtm_y: ['incrementalSkuViewedCategory'],
            yr_gtm_z: ['skuListUnfinishedOrders'],
            ecomm_pagetype: ['pageTemplate'],
            yr_gtm_a: ['shop', 'campaignAction'],
            yr_gtm_ac: ['urlCampaignCode'],
            yr_gtm_c: ['campaignCode1'],
            yr_gtm_ad: ['campaignCode2'],
        };
        this.orderHash = null;
        this.dynamicLoaded = false;
        this.extendDataLayer = extendDataLayer_1.default;
        this.serverParams = null;
        this.page = new PageAnalyze_1.default(document, location);
        this.interactions = new GtmInteractions_1.default(this, this.page);
        window.gtmConverteoInteractions = this.interactions;
        window.document.dispatchEvent(new Event('gtmConverteoLoaded'));
    }
    /**
     * Przekaż do obiektu informacje o standardowych parametrach generowanych
     * dla GTM
     * @param {Object} vars
     */
    GtmConverteo.prototype.pushDataLayerVariables = function (vars) {
        try {
            this.extendDataLayer(this.translateStandardVariables(vars));
        }
        catch (e) {
            console.error('Failed to translate GTM variables: ', e);
        }
    };
    /**
     * Zmapuj standardowe parametry GTM na parametry Converteo
     * @param {Object} vars
     * @return {ParamsContainer}
     */
    GtmConverteo.prototype.translateStandardVariables = function (vars) {
        var _this = this;
        var mapped = {};
        Object.keys(vars).forEach(function (key) {
            if (typeof _this.mapping[key] !== 'undefined') {
                _this.mapping[key].forEach(function (param) {
                    mapped[param] = vars[key];
                });
            }
        });
        return mapped;
    };
    /**
     * Ustaw informację, że akcja /dynamic została załadowana
     */
    GtmConverteo.prototype.setDynamicLoaded = function () {
        this.dynamicLoaded = true;
        this.loadAdditionalParams();
    };
    /**
     * Załaduj asynchronicznie dodatkowe parametry dataLayer z użyciem
     * metody /gtm-converteo/params
     */
    GtmConverteo.prototype.loadAdditionalParams = function () {
        var _this = this;
        var params = new URLSearchParams({
            orderHash: this.orderHash || '',
        });
        fetch("/gtm-converteo/params?" + params.toString())
            .then(function (response) {
            if (response.ok !== true) {
                throw new Error("Invalid response: " + response.statusText);
            }
            return response;
        })
            .then(function (response) { return response.json(); })
            .then(function (responseParams) {
            _this.serverParams = responseParams;
            _this.extendDataLayer(responseParams);
            _this.generateParamsFromFrontend();
        })
            .catch(function (error) {
            console.log('Failed to load GTM Converteo params: ', error);
        });
    };
    /**
     * Wygeneruj parametry dataLayer na podstawie tego, co można ustalić
     * korzystając z danych w przeglądarce
     */
    GtmConverteo.prototype.generateParamsFromFrontend = function () {
        var data = {
            pageID: this.page.getLocationPath(),
            platform: 'tauceti',
        };
        this.generateSearchInfo(data);
        this.generateBreadcrumbs(data);
        data.list = this.page.getProductsLists();
        data.checkoutStep = this.page.getCheckoutStep();
        this.extendDataLayer(data);
    };
    /**
     * Wygeneruj parametry przedstawiające elementy breadcrumba
     * @param {Object} data
     */
    GtmConverteo.prototype.generateBreadcrumbs = function (data) {
        var breadcrumbs = this.page.getBreadcrumbs();
        data.breadcrumb0 = '';
        data.breadcrumb1 = '';
        data.breadcrumb2 = '';
        data.breadcrumb3 = '';
        data.breadcrumb4 = '';
        if (breadcrumbs.length > 0) {
            var i_1 = 0;
            breadcrumbs.forEach(function (element) {
                if (i_1 <= 4) {
                    data["breadcrumb" + i_1] = element;
                }
                i_1 += 1;
            });
        }
    };
    /**
     * Wygeneruj parametry związane z wynikami wyszukiwania
     * @param {Object} data
     */
    GtmConverteo.prototype.generateSearchInfo = function (data) {
        var info = this.page.getSearchInfo();
        data.searchKeyword = info.phrase;
        data.nbResults = info.totalProducts;
    };
    /**
     * Ustaw ID zamówienia/koszyka
     * @param {string|null} hash
     */
    GtmConverteo.prototype.setOrderHash = function (hash) {
        this.orderHash = hash;
    };
    return GtmConverteo;
}());
exports.default = GtmConverteo;
